import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import auth from './auth';
import substationDevices from './substation-devices';
import projectSubstations from './project-substations';
import projects from './projects';
import device from './device';
import deviceEvents from './device-events';
import deviceGuardProbes from './device-guard-probes';
import events from './events';
import feederDiagram from './feeder-diagram';
import user from './user';
import users from './users';
import mutations from './mutations';
import waveforms from './waveforms';
import waveformDetails from './waveform-details/index';
import substation from './substation';
import substationVisnetHub from './substation-visnet-hub';
import electricalData from './visnet-hub-chart-electrical';
import powerQualityData from './visnet-hub-chart-power-quality';
import environmentalData from './visnet-hub-chart-environmental';
import guard1000 from './guard-1000';
import guard1000FaultPanelData from './guard-1000-fault-panel-data';
import guard1000FaultEvents from './guard-1000-fault-events';
import guard1000FaultWaveforms from './guard-1000-fault-waveforms';
import guard1000FaultElectricalDataImpedance from './guard-1000-electrical-data-impedance';
import guard1000Probes from './guard-1000-probes';
import visnetHubFaultPanelData from './visnet-hub-fault-panel-data';
import visnetHubFaultEvents from './visnet-hub-fault-events';
import visnetHubFaultWaveforms from './visnet-hub-fault-waveforms';
import visnetHubFaultElectricalData from './visnet-hub-fault-electrical-data';
import visnetHubFaultElectricalDataImpedance from './visnet-hub-fault-electrical-data-impedance';
import visnetHubModemLog from './visnet-hub-modem-log';
import modemLogEvents from './modem-log-events';
import project from './project';
import agent from './agent';
import waveform from './waveform';
import passwords from './passwords';
import userInfo from './user-info';
import getters from './getters';
import licenceAreas from './licence-areas';
import licenceAreaZones from './licence-area-zones';
import zones from './zones';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    deviceEvents,
    substationVisnetHub,
    substationDevices,
    waveforms,
    projectSubstations,
    projects,
    device,
    deviceGuardProbes,
    events,
    feederDiagram,
    user,
    users,
    waveformDetails,
    electricalData,
    powerQualityData,
    environmentalData,
    guard1000,
    guard1000FaultPanelData,
    guard1000FaultEvents,
    guard1000FaultWaveforms,
    guard1000FaultElectricalDataImpedance,
    guard1000Probes,
    visnetHubFaultPanelData,
    visnetHubFaultEvents,
    visnetHubFaultWaveforms,
    visnetHubFaultElectricalData,
    visnetHubFaultElectricalDataImpedance,
    visnetHubModemLog,
    modemLogEvents,
    substation,
    project,
    agent,
    waveform,
    passwords,
    userInfo,
    licenceAreas,
    licenceAreaZones,
    zones
  },
  state: {
    activeLoaders: {},
    loading: false,
    error: null,
    backToPath: '/',
    sidebarOpen: true,
    activeTimezone: null
  },
  mutations,
  actions,
  getters
});
